// https://github.com/airbnb/react-dates/blob/master/src/components/SingleDatePicker.jsx

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { SingleDatePicker } from 'react-dates';
import dateFormatService from '../../services/DateFormatService';

const returnYears = () => {
  const years = [];
  for (let i = moment().year() - 5; i <= moment().year() + 5; i++) {
    years.push(<option value={i}>{i}</option>);
  }
  return years;
};

const renderMonthElement = ({ month, onMonthSelect, onYearSelect }) => (
  <div style={{ display: 'flex', justifyContent: 'center' }}>
    <div>
      <select
        className="form-control"
        value={month.month()}
        onChange={e => onMonthSelect(month, e.target.value)}
      >
        {moment.months().map((label, value) => (
          <option value={value}>{label}</option>
        ))}
      </select>
    </div>
    <div>
      <select
        className="form-control"
        value={month.year()}
        onChange={e => onYearSelect(month, e.target.value)}
      >
        {returnYears()}
      </select>
    </div>
  </div>
);

class DatePicker extends Component {
  internalOnDateChange = (date, onDateChange) => {
    const inputValue = document.getElementById(this.props.id)?.value;
    if (inputValue) {
      const parsedInputValue = moment(inputValue, dateFormatService.dateFormat(), true);
      const isDateValid = parsedInputValue.isValid() === true;
      onDateChange(date, isDateValid);
    } else {
      onDateChange(date, true);
    }
  };

  render() {
    const { phrases, numberOfMonths, onDateChange, ...rest } = this.props;
    return (
      <SingleDatePicker
        numberOfMonths={numberOfMonths}
        keepFocusOnInput
        onDateChange={date => this.internalOnDateChange(date, onDateChange)}
        hideKeyboardShortcutsPanel
        renderMonthElement={renderMonthElement} // this method adds a dropdown for both month and year, so that the user doesnt have to navigate to previous years using the arrows
        displayFormat={dateFormatService.dateFormat()} // hardcoded for now, since the EN-culture changes the date format to MM/DD/YYYY and this is not wanted behavior in South-African tenants
        {...rest}
      />
    );
  }
}

DatePicker.propTypes = {
  numberOfMonths: PropTypes.number,
  phrases: PropTypes.shape({}),
};
DatePicker.defaultProps = {
  phrases: {},
  numberOfMonths: 1,
};

export default DatePicker;
